module.exports = __webpack_public_path__ + "static/media/downloadApple.a1596cb8.png";